<template>
  <landing-page label="factSheet.information&factSheet" labelColor="#603813" descColor="#603813" :eggImgObj="{ componentName: 'factsheet', imgName: 'factSheetIntro', imgFormat: 'png' }" :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }" />
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>